export default {
    data () {
        return {
            showArchivingModal: false,
            isArchiving: null,
        };
    },
    methods: {
        archiveOrUnarchiveModel (archiving) {
            this.isArchiving = archiving;
            this.toggleArchivingModal();
        },

        toggleArchivingModal () {
            this.showArchivingModal = !this.showArchivingModal;
            if (!this.showArchivingModal) {
                this.isArchiving = null;
            }
        },
    },
};
